module.exports = __webpack_public_path__ + "5.0.2/img/logo_juzhen.269cf06b.png";